import { render } from "./sleep.vue?vue&type=template&id=1bd18b09&scoped=true"
import script from "./sleep.vue?vue&type=script&lang=js"
export * from "./sleep.vue?vue&type=script&lang=js"

import "./sleep.vue?vue&type=style&index=0&id=1bd18b09&scoped=true&lang=css"

import exportComponent from "/Users/atomu/Desktop/GitHub/good_neet/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bd18b09"]])

export default __exports__